import {isFeatureEnabled} from '@github-ui/feature-flags'
import {PreheatIssuesManager} from '@github-ui/preheat-issues-manager'

const manager = new PreheatIssuesManager({
  isEnabled: () => !isFeatureEnabled('disable_preheating_for_issues'),
  source: 'discussions',
  tabbedTimeline: isFeatureEnabled('issues_react_timeline_tabs'),
})

manager.start()
